var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Spin } from 'antd';
var SpinA11y = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'spinner' : _b, spinning = _a.spinning, children = _a.children, rest = __rest(_a, ["name", "spinning", "children"]);
    var spinnerLabel = name ? "".concat(name, " loading") : '';
    var spinnerTestId = spinning ? "".concat(name, "SpinnerLoading") : "".concat(name, "SpinnerIdle");
    return (_jsx("div", { "data-test": spinnerTestId, "aria-busy": spinning, "aria-live": "polite", role: "status", "aria-label": spinnerLabel, style: { display: 'contents' }, children: _jsx(Spin, __assign({ spinning: spinning }, rest, { children: children })) }));
};
export default SpinA11y;
